import React from 'react';
import { Stack, Text } from '@moda/om';
import './PayPalPaymentMethodPreview.scss';

export const PayPalPaymentMethodPreview: React.FC = ({ children }) => (
  <Stack space={0} className="PayPalPaymentMethodPreview">
    <Stack space={1} direction="horizontal" alignItems="center">
      <img className="PayPalPaymentMethodPreview__logo" src="/paypal.svg" alt="PayPal" />
      <Text treatment="eyebrow">Payment Method</Text>
    </Stack>
    <Stack space={0} direction="horizontal" justifyContent="space-between">
      <Text>Your selected PayPal Payment Method</Text>
      {children}
    </Stack>
  </Stack>
);
